<script lang="ts" setup>
defineProps<{
  url?: string
}>()

const { t } = useI18n()
</script>

<template>
  <v-app-bar color="warning" app flat>
    <div class="d-flex justify-center flex-grow-1">
      <div class="d-flex align-center">
        <v-icon size="20">custom:warning</v-icon>
        <i18n-t class="text-body-2 ml-2" tag="span" keypath="maintenance.light.text">
          <template #link>
            <nuxt-link class="text-white" :href="url">{{ t('maintenance.light.link_text') }}</nuxt-link>
          </template>
        </i18n-t>
      </div>
    </div>
  </v-app-bar>
</template>
